import { Route } from 'react-router-dom';
import { AppRoute } from 'app/routes';
import UserPrivateRoute from './UserPrivateRoute';
import { UserTypes } from 'features/types';
import JobSeekerPrivateRoute from './JobSeekerPrivateRoute';
import { useAppSelector } from 'app/hooks';
import { selectUser } from 'features/auth';

const RouteWrapper = (props: AppRoute) => {
  const { userType, ...routeProps } = props;
  const user = useAppSelector(selectUser);
  const routeUserType = Array.isArray(userType) ? (user ? UserTypes.User : UserTypes.JobSeeker) : userType;

  let RenderRoute;
  switch (routeUserType) {
    case UserTypes.User:
      RenderRoute = UserPrivateRoute;
      break;
    case UserTypes.JobSeeker:
      RenderRoute = JobSeekerPrivateRoute;
      break;
    default:
      RenderRoute = Route;
      break;
  }

  return <RenderRoute {...routeProps} />;
};

export default RouteWrapper;
